export default "__VITE_ASSET__CXQPO4TP__"